import { inject } from "mobx-react";

import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import type { PreviousNextItemFragment } from "@ihr-radioedit/inferno-webapi";
import { placeholderImage } from "@ihr-radioedit/inferno-core";
import { formatImage } from "@ihr-radioedit/inferno-core";
import { MagicLink } from "@inferno/renderer-shared-ui";
import { CoastFeedItemType, getCoastFeedImg } from "../../lib/coastFeed";
import { RESPONSIVE_IMAGE } from "@inferno/renderer-shared-core";
import type { Store } from "@inferno/renderer-shared-core";

interface CoastPreviousNextItemProps {
  item: PreviousNextItemFragment;
  type: "previous" | "next";
  basePath: string | null;
  store?: Store;
}

export const CoastPreviousNextItem = inject("store")(({ item, type, basePath, store }: CoastPreviousNextItemProps) => {
  if (!store) {
    return null;
  }

  const { summary } = item;

  const thumb = formatImage(summary.image || placeholderImage, store.env.IMAGE_HOST);
  const { imgSrc, srcset } = getCoastFeedImg(thumb, CoastFeedItemType.SHOW, { quality: 80 });
  const itemUrl = basePath ? `${basePath}/${item.slug || ""}` : "#";

  return (
    <div className={`component-coast-previous-next-item ${type}`}>
      <MagicLink to={itemUrl} context={item.slug || undefined}>
        <figure className="item-thumb">
          <ResponsiveImage
            alt={summary.title}
            src={imgSrc}
            srcset={srcset}
            initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
            initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
          />

          <figcaption>{item.summary.title}</figcaption>
        </figure>
      </MagicLink>

      <MagicLink className="more-link" to={itemUrl} context={item.slug || undefined}>
        {type === "next" ? `${type} >>` : `<< ${type}`}
      </MagicLink>
    </div>
  );
});
